import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Grid, IconButton, Stack, Tooltip } from "@mui/material";
import {
  useDeleteFacultyGroupMutation,
  useFacultyGroupsListQuery,
} from "api/facultyGroups/facultyGroups.mutation";
import ExcelIcon from "assets/admin/excel.svg";
import { ConfirmDeleteModal } from "components/ConfirmDeleteModal";
import SearchField from "components/SearchField";
import { Table } from "components/Table";
import { exportToExcel } from "constants/export";
import { handleError } from "functions/apiHandleError";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CreateUpdateFacultyGroupModal } from "./components/createUpdateModal";
import classes from "./style.module.scss";

const FacultyGroups = () => {
  const [searchParams] = useSearchParams();
  const paramPage = Number(searchParams.get("page")) || 1;

  const [searchValue, setSearchValue] = useState("");
  const [pageFilter, setPageFilter] = useState({
    page: paramPage,
    page_size: 15,
    total: 1,
    count: 0,
  });
  const [createUpdateModal, setCreateUpdateModal] = useState({
    open: false,
    selectedGroup: null,
  });
  const [deleteModal, setDeleteModal] = useState({ open: false, selectedGroup: null });

  const facultyGroupsQuery = useFacultyGroupsListQuery({
    page: pageFilter.page,
    page_size: pageFilter.page_size,
    search: searchValue,
  });
  const deleteFacultyGroupMutation = useDeleteFacultyGroupMutation();
  const tableData = facultyGroupsQuery.data?.results ?? [];
  const totalPages = facultyGroupsQuery.data?.total ?? pageFilter.total;

  const handleCloseCreateUpdateModal = () => {
    setCreateUpdateModal({
      open: false,
      selectedGroup: null,
    });
  };
  const handleDeleteFacultyGroup = async () => {
    const facultyID = deleteModal.selectedGroup?.id;
    if (!facultyID) return;

    try {
      await deleteFacultyGroupMutation.mutateAsync(facultyID);
      setDeleteModal({ open: false, selectedGroup: null });
    } catch (err) {
      handleError({ err });
    }
  };

  useEffect(() => {
    if (pageFilter.page !== paramPage) {
      setPageFilter((prev) => ({
        ...prev,
        page: paramPage,
      }));
    }
  }, [paramPage]);

  const columns = [
    {
      field: "name",
      headerName: "نام گروه",
      minWidth: 220,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "faculty_display",
      headerName: "دانشکده",
      minWidth: 130,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "fields_display",
      headerName: "رشته ها",
      minWidth: 120,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => row?.fields_display?.join(", "),
    },
    {
      field: "actions",
      headerName: "عملیات",
      minWidth: 100,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <Stack spacing={2} direction="row">
          <Tooltip title="ویرایش">
            <IconButton
              color="primary"
              onClick={() =>
                setCreateUpdateModal({
                  open: true,
                  selectedGroup: row,
                })
              }
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="حذف">
            <IconButton
              color="error"
              onClick={() => setDeleteModal({ open: true, selectedGroup: row })}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <>
      <div className={classes.mainDiv}>
        <div className={classes.toolBar}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <SearchField setValueCallback={setSearchValue} variant="standard" />
            </Grid>
            <Grid item xs={0} md={4} />
            <Grid item xs={12} md={4}>
              <div className={classes.manageBar}>
                <Tooltip title="ایجاد دانشکده">
                  <IconButton
                    onClick={() => setCreateUpdateModal({ open: true, selectedFaculty: null })}
                    color="success"
                  >
                    <AddCircleIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="خروجی اکسل">
                  <IconButton
                    onClick={() => exportToExcel(columns, tableData, "facultyGroups.xlsx")}
                    color="success"
                  >
                    <img src={ExcelIcon} alt="export-excell" className={classes.customIcon} />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
        </div>
        <Table
          rows={tableData}
          columns={columns}
          totalPages={totalPages}
          loading={facultyGroupsQuery.isFetching || deleteFacultyGroupMutation.isPending}
          className={classes.tableContainer}
        />
      </div>
      <CreateUpdateFacultyGroupModal
        open={createUpdateModal.open}
        onClose={handleCloseCreateUpdateModal}
        defaultData={createUpdateModal.selectedGroup}
      />
      <ConfirmDeleteModal
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, selectedGroup: null })}
        onConfirm={handleDeleteFacultyGroup}
        loading={deleteFacultyGroupMutation.isPending}
        title="حذف گروه آموزشی"
        message="آیا از حذف گروه آموزشی انتخاب‌شده مطمئن هستید؟ این عملیات قابل بازگشت نیست."
      />
    </>
  );
};

export default FacultyGroups;
